module.exports = __webpack_public_path__ + "dashboard/img/drag.c0e699169ca0f4185f88d64728485822.svg";